import React from 'react';
import cn from 'classnames';
import Loader from '../../Atoms/Loader';

import classes from './styles.module.scss';

const LoaderBlock = ({overlay, text}) => {
    return (
        <div className={ cn(classes.root, {[classes.overlay]: overlay}) }>
            <Loader className={ classes.loader } />
            <div className={ classes.message }>
                {
                    text ? text : 'FETCHING DATA'
                }
            </div>
        </div>
    );
};

export default LoaderBlock;
